import _ from 'lodash'

import Resource from '@/models/api/resource'

export class ApiPaymentSetting extends Resource {
}

export class ApiPaymentSettingList {

  static valueOf(settings: ApiPaymentSetting[]): ApiPaymentSettingList {
    return new ApiPaymentSettingList(settings)
  }

  static empty(): ApiPaymentSettingList {
    return new ApiPaymentSettingList([])
  }

  private constructor(
    private settings: ApiPaymentSetting[]
  ) {}

  get list(): ApiPaymentSetting[] {
    return this.settings
  }

  some(predicate: (setting: ApiPaymentSetting) => boolean): boolean {
    return _.some(this.settings, predicate)
  }

  get ids(): string[] {
    return this.settings.map(s => s.id)
  }
}
